/**
 * frontend/src/modules/phenomena/hooks/usePhenomenaActive.ts
 *
 * TanStack Query v5 — phénomènes actifs P1 (V4.20).
 *
 * Filtre client-side sur `nature` (MARCHE / OPS) via `filterByNature`.
 * Le backend n'expose que week_iso/severity/kpi/pattern_type côté query string —
 * `nature` est lue depuis le DTO côté client (source unique = catalogue backend).
 */

import { useQuery } from '@tanstack/react-query'
import { fetchActivePhenomena, type ActivePhenomenaParams } from '../lib/api'
import { filterByNature } from '../lib/aggregations'
import type { Nature, Phenomenon } from '../types/phenomena.types'

export const PHENOMENA_ACTIVE_QK = ['phenomena', 'active'] as const

export interface UsePhenomenaActiveOptions extends ActivePhenomenaParams {
  /** Filtre client-side sur la nature (MARCHE vue Marché, OPS vue Performance). */
  nature?: Nature
}

export function usePhenomenaActive(options?: UsePhenomenaActiveOptions) {
  const { nature, ...params } = options ?? {}
  return useQuery({
    queryKey:  [...PHENOMENA_ACTIVE_QK, params],
    queryFn:   () => fetchActivePhenomena(params),
    staleTime: 60_000,
    select:    (resp) => {
      const all: Phenomenon[] = resp.data
      const filtered = nature ? filterByNature(all, nature) : all
      // `PHENOMENA-MOTEUR-AVALE-LES-PANNES` — remonte `degraded` (lecture en
      // échec) pour distinguer « erreur » de « semaine vide » côté écran.
      return { data: filtered, weekIso: resp.weekIso, allCount: all.length, degraded: resp.meta?.degraded ?? false }
    },
  })
}
